import React from "react"

import style from "./AvailableDeliverySlots.module.scss"

function AvailableDeliverySlots(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slots, isTakeaway = false } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function uniqueBy(arr, fn) {
    let unique = {}
    let distinct = []
    arr.forEach(function (x) {
      const key = fn(x)

      if (!unique[key]) {
        distinct.push(x)
        unique[key] = true
      }
    })
    return distinct
  }

  function renderFirstSlot(slots, isTakeAway) {
    if (slots.length === 0) {
      return <b>{I18n.t("service_ordering.exausted_deliveries_for_today")}</b>
    }

    const firstSlot = uniqueBy(slots, function (x) {
      return x.start_time
    })[0]

    const { date, start_time, end_time, picking_times } = firstSlot

    if (isTakeAway) {
      const firstPickingTime = picking_times[0]
      return <span className={style.deliveryTime}>{firstPickingTime}</span>
    } else {
      let label = `${I18n.t("today")}, ${start_time}-${end_time}`
      if (date) {
        let jsDate = new Date(date)
        if (jsDate.getDate() !== new Date().getDate()) {
          label = `${jsDate.toLocaleString(I18n.locale, {
            weekday: "short",
            day: "2-digit",
          })}, ${start_time}`
        }
      }
      return <span className={style.deliveryTime}>{label}</span>
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.container}>
      <i className={`fal fa-clock ${style.icon}`} />
      <p className={`fr-p3 fr-normal ${style.paragraph}`}>
        {isTakeaway
          ? I18n.t("service_ordering.first_pickup")
          : I18n.t("service_ordering.first_delivery")}

        {!slots && <i>{I18n.t("service_ordering.getting_delivery_times")}</i>}
        {!!slots && renderFirstSlot(slots, isTakeaway)}
      </p>
    </div>
  )
}

export default AvailableDeliverySlots
